// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qnwp","colBig":"styles_colBig__15uCz","colSmall":"styles_colSmall__3gtO_","shopifyNameWrapper":"styles_shopifyNameWrapper__YT3oQ"};